(function($) {
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', init) 
  
  function init() {
    hideZeroPrice()
  }

  function hideZeroPrice() {
    const builder = $('#product-builder')
    const price = $('.cpb-product-price')

    checkPrice()
    new MutationObserver(checkPrice).observe(price[0], {subtree: true, characterData: true})

    function checkPrice() {
      builder.attr('data-custom-zero-price', true)
    }
  }
  
})(jQuery);
